/* ==========================================================================
   Report enquiries to Google Ads and GA4.

   Most of this shop's orders do not start at the checkout. People find a DTF
   or UV DTF ad, decide they need to talk to somebody about artwork, and send a
   WhatsApp - the sale happens by hand afterwards. Google never sees any of
   that, so a campaign that is working reads as zero conversions, and Smart
   Bidding spreads the budget evenly across every keyword because none of them
   look better than the others.

   This reports the moment somebody reaches for a way to talk to you. That is
   the conversion for this business.

   Listens on the document rather than on the buttons themselves. There are two
   WhatsApp links today (the floating one and the contact page), phone and mail
   links in three places, and there will be more. A delegated listener catches
   whatever gets added later without anybody remembering to instrument it.

   Silent when no tag is installed. gtag arrives with the Google & YouTube
   channel; until then every call here is a no-op rather than an error in the
   console of a live shop.
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.EUEnquiryTracking || {};

  /* href pattern -> the event name reported. Ordered: the first match wins, so
     wa.me is tested before the generic tel: catch. */
  var KINDS = [
    [/^(https?:)?\/\/(api\.)?wa\.me\//i, 'whatsapp_click'],
    [/^(https?:)?\/\/(api|web)\.whatsapp\.com\//i, 'whatsapp_click'],
    [/^whatsapp:/i, 'whatsapp_click'],
    [/^tel:/i, 'phone_click'],
    [/^mailto:/i, 'email_click'],
  ];

  function kindOf(href) {
    for (var i = 0; i < KINDS.length; i++) {
      if (KINDS[i][0].test(href)) return KINDS[i][1];
    }
    return null;
  }

  /* One enquiry per kind per page view. Somebody who taps the WhatsApp button,
     comes back and taps it again has not enquired twice, and counting it twice
     would tell Google that page converts at double the rate it does. */
  var fired = {};

  function report(kind, href) {
    if (fired[kind]) return;
    fired[kind] = true;

    var label = {
      whatsapp_click: 'WhatsApp',
      phone_click: 'Phone',
      email_click: 'Email',
    }[kind];

    /* GA4, and anything importing GA4 events as Ads conversions. */
    if (typeof window.gtag === 'function') {
      window.gtag('event', kind, {
        event_category: 'Enquiry',
        event_label: label,
        page_location: window.location.href,
        /* The link opens a new tab or an app, so the page survives and there is
           time to send normally. beacon anyway: it costs nothing and covers the
           case where a browser decides otherwise. */
        transport_type: 'beacon',
      });

      /* A Google Ads conversion proper, only once somebody has created the
         action and pasted its send_to here. Without it the GA4 event above is
         still importable in Ads, which is the easier route and needs no ID. */
      var sendTo = cfg.conversions && cfg.conversions[kind];
      if (sendTo) {
        window.gtag('event', 'conversion', { send_to: sendTo, transport_type: 'beacon' });
      }
    }

    /* Google Tag Manager, if it is ever used instead. */
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: kind, enquiry_method: label, enquiry_href: href });
    }

    if (cfg.debug && window.console) {
      console.log('[enquiry] ' + kind + ' -> ' + href + (typeof window.gtag === 'function' ? '' : '  (no gtag yet)'));
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var kind = kindOf(href);
    if (kind) report(kind, href);
  }, true);
})();
